import { useState, useEffect, useRef } from 'react';

// Carousel data with background images and content
const carouselData = [
  {
    id: 1,
    imageSrc: "https://img.freepik.com/free-photo/inclusive-education-concept_23-2149313797.jpg?ga=GA1.1.443924539.1743055355&semt=ais_hybrid&w=740",
    title: "SAP Staff Augmentation & Staffing Services",
    description: "Scale Your SAP Projects with Expert Talent — On Demand",
    buttonText: "Get Started",
    buttonLink: "/contact",
    bgColor: "#1e40af"
  },
  {
    id: 2,
    imageSrc: "https://img.freepik.com/free-photo/business-people-working-with-laptop-office_23-2148017102.jpg?ga=GA1.1.443924539.1743055355&semt=ais_hybrid&w=740",
    title: "Seamless Integration",
    description: "Our SAP experts integrate seamlessly into your teams, ensuring continuity and quality",
    buttonText: "Learn More",
    buttonLink: "/services",
    bgColor: "#1e3a8a"
  },
  {
    id: 3,
    imageSrc: "https://img.freepik.com/free-photo/colleagues-working-together-call-center-office_23-2149256108.jpg?ga=GA1.1.443924539.1743055355&semt=ais_hybrid&w=740",
    title: "Extended Team Model",
    description: "We act as your extended arm in sourcing and deploying SAP talent",
    buttonText: "View Solutions",
    buttonLink: "/solutions",
    bgColor: "#0f2a67"
  }
];

const Carousel = ({contact}) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slideInterval = useRef(null);
  
  // Auto-scroll functionality
  useEffect(() => {
    slideInterval.current = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % carouselData.length);
    }, 5000);
    
    return () => {
      if (slideInterval.current) {
        clearInterval(slideInterval.current);
      }
    };
  }, []);
  console.log(contact)


  const handledowntocontact = () => {
    contact.current.scrollIntoView({ behavior: 'smooth' });
  }
  // Handle manual navigation
  const goToSlide = (index) => {
    setCurrentSlide(index);
    if (slideInterval.current) {
      clearInterval(slideInterval.current);
      slideInterval.current = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % carouselData.length);
      }, 5000);
    }
  };

  // Animation for the auto-scrolling effect
  const slideAnimation = {
    transform: `translateX(-${currentSlide * 100}%)`
  };

  return (
    <div className="relative w-full h-full flex flex-col">
      {/* Carousel Container */}
      <div className="w-full overflow-hidden relative">
        <div 
          className="flex transition-transform duration-700 ease-in-out"
          style={slideAnimation}
        >
          {carouselData.map((slide) => (
            <div key={slide.id} className="w-full flex-shrink-0">
              <div className="flex flex-col md:flex-row h-full">
                {/* Left side - Background image */}
                <div className="w-full md:w-1/2 h-64 md:h-96 relative">
                  <img 
                    src={slide.imageSrc} 
                    alt={slide.title} 
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0" style={{ backgroundColor: 'rgba(30, 58, 138, 0.4)' }}></div>
                </div>
                
                {/* Right side - Content */}
                <div 
                  className="w-full md:w-1/2 p-6 md:p-12 flex flex-col justify-center items-start h-64 md:h-96"
                  style={{ background: `linear-gradient(to right, ${slide.bgColor}, ${slide.bgColor}CC)` }}
                >
                  <h2 className="text-white text-2xl md:text-3xl font-bold mb-4">{slide.title}</h2>
                  <p style={{ color: '#dbeafe' }} className="text-lg mb-6">{slide.description}</p>
                  <button 
                    className="px-6 py-3 rounded-md font-medium transition-colors duration-300"
                    style={{ backgroundColor: '#ffffff', color: slide.bgColor }}
                    onMouseOver={(e) => e.target.style.backgroundColor = '#f0f9ff'}
                    onMouseOut={(e) => e.target.style.backgroundColor = '#ffffff'}
                    // onClick={() => console.log(`Navigate to: ${slide.buttonLink}`)}
                    onClick={(e)=> handledowntocontact(e)}
                  >
                    {slide.buttonText}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      {/* Navigation Dots */}
      <div className="flex justify-center mt-4 gap-2">
        {carouselData.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`w-3 h-3 rounded-full transition-colors duration-300`}
            style={{ 
              backgroundColor: currentSlide === index ? '#2563eb' : '#93c5fd'
            }}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default Carousel;